import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

let hotjarScriptLoaded = false;

export const resetHotjarScriptLoaded = () => {
    hotjarScriptLoaded = false;
};

const loadHotjarScript = () => {
    if (!window.config?.HOTJAR || hotjarScriptLoaded || window.hj || navigator.userAgent === 'selenium') {
        return;
    }

    hotjarScriptLoaded = true;

    /* eslint-disable */
    (function (h, o, t, j, a, r) {
        h.hj =
            h.hj ||
            function () {
                (h.hj.q = h.hj.q || []).push(arguments);
            };
        h._hjSettings = { hjid: 1044719, hjsv: 6 };
        a = o.getElementsByTagName('head')[0];
        r = o.createElement('script');
        r.async = 1;
        r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        a.appendChild(r);
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
    /* eslint-enable */
};

const Hotjar = ({ children }) => {
    const userInfo = useSelector(store => store.userInfo);

    const shouldLoadHotjar = Boolean(userInfo?.role);

    React.useEffect(() => {
        if (!shouldLoadHotjar) {
            return;
        }

        loadHotjarScript();

        if (window.hj && (userInfo?.userId || userInfo?.id)) {
            const userId = userInfo.userId || userInfo.id;
            window.hj('identify', userId, {
                'User ID': userId,
                'District ID': userInfo.districtId,
                'School ID': userInfo.schoolId,
                'User Role': userInfo.role,
                'Trial District Status': userInfo.isTrialDistrict,
            });
        }
    }, [userInfo, shouldLoadHotjar]);

    return <>{children}</>;
};

Hotjar.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Hotjar;
